<div id="content">
  <div class="page-title">
    <app-company-product-page-identity />
    <h1>{{ page_title }}</h1>
    <button mat-flat-button color="accent" [disabled]="!canManage()" [routerLink]="['create']">
      <mat-icon style="margin-right: 10px">add</mat-icon>
      Crear nueva aplicación
    </button>
  </div>

  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let app">{{ app.name }}</td>
        </ng-container>

        <ng-container matColumnDef="git">
          <th mat-header-cell *matHeaderCellDef>Github URL</th>
          <td mat-cell *matCellDef="let app">
            @if (app.git_url) {
              <a mat-flat-button [href]="app.git_url" target="_blank">
                <mat-icon>open_in_new</mat-icon>
                Abrir en Github
              </a>
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="github_status">
          <th mat-header-cell *matHeaderCellDef>Estado GitHub</th>
          <td mat-cell *matCellDef="let app">
            @if (app.git_url) {
              @if (app.github_token_set) {
                <mat-chip color="success">Configurado</mat-chip>
              } @else {
                <mat-chip color="warn">Sin configurar</mat-chip>
              }
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let app; let i = index">
            @if (canManage()) {
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item [routerLink]="[app.id]">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="delete(app)">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
